export default __webpack_public_path__ + "static/media/Wheat.b4f1bcb4.jpg";